import { Form, Formik,Field } from "formik";
import React, { useContext, useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import "../../../components/customer-information/customer-information.css";
import { useDispatch } from "react-redux";
import AddButton from "../../buttons/button";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import InputField from "../../forms/input-field";
import SelectField from "../../forms/select-field";
import excelImg from "../../../assets/icons/excel.png"
import {
  roundingMethodoptions,
  roundingRuleoptions,
} from "../../helper-components/data";
import { priceListAction } from "../../../redux/actions/general-action";
import { priceListEditAction,priceListEditByCSVAction } from "../../../redux/actions/discount-action";
import PriceListItemTable from "./price-list-items-table";
import SelectionCriteriaPopover from "./price-list-popover";
import { useHotkeys } from "react-hotkeys-hook";
import CheckBox from "../../forms/check-box-field";
import { DownloadIcon, SearchIcon } from "lucide-react";
import Select from "react-select";
import Papa from "papaparse";
import { downloadAllTemplates } from "../../helper-components/helper-function";
import { DataContext } from "../../layouts/main-layout";

const CreateEditViewPriceList = ({
  paginationProps,
  priceListData,
  setFilterData,
  filterData,
  setReload,
  reload,
  type,
}) => {
  const { permissionFn } = useContext(DataContext);
  const canUpdatePriceList =
    type !== "view" && permissionFn("price_list")?.update === true;
  const [selectionCriteria, setSelectionCriteria] = useState(false);
  const dispatch = useDispatch();
  const [priceList, setPriceList] = useState([]);
  const [isFocused, setIsFocused] = useState(false);
  const [csvLoading,setLoading]=useState(false);
  const [priceListConfig,setPirceListConfig]=useState([]);
  useEffect(() => {
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const billingData = parsed.find((obj) => obj?.price_list_type);
      if (billingData?.price_list_type) {
        setPirceListConfig(billingData.price_list_type);
      }
    }
  }, []);
  const columnOptions=[
                        {
                          "label":"Item Name",
                          "value":"item_name"
                        },
                        {
                          "label":"Item Code",
                          "value":"item_code"
                        }
                      ]
  useEffect(() => {
    dispatch(priceListAction(onpriceSuccess, onpriceError));
  }, []);
  const onpriceSuccess = (data) => {
    setPriceList(
      data?.data?.map((item) => {
        return { label: item?.price_list_name, value: item?.price_list_id };
      })
    );
  };
  const onpriceError = (data) => {
    // errorToast(data?.message);
  };
  function getPricingType(values) {
    if (values?.item_batch_mrp) return "MRP";
    if (values?.item_batch_purhcase_rate_before_tax) return "PR";
    if (values?.item_batch_ptr) return "PTR";
    if (values?.item_batch_pts) return "PTS";
    return "";
  }
  const initialValues = {
    price_list_id: priceListData?.pricelist?.price_list_id,
    price_list_name: priceListData?.pricelist?.price_list_name ?? "",
    default_base_price_list_id:
      priceListData?.pricelist?.default_base_price_list_id ?? "",
    default_factor: priceListData?.pricelist?.default_factor ?? "",
    margin_factor: priceListData?.pricelist?.margin_factor ?? "",
    rounding_method: priceListData?.pricelist?.rounding_method ?? "",
    rounding_rule: priceListData?.pricelist?.rounding_rule ?? "",
    default_price_list: Boolean(priceListData?.pricelist?.default_price_list),
    is_margin_percentage:
      priceListData?.pricelist?.is_margin_percentage ?? false,
    pricing_type:getPricingType(priceListData?.pricelist)
  };

  const validationSchema = Yup.object().shape({
    price_list_name: Yup.string().required("Price list name is required"),
    default_base_price_list_id: Yup.string().required(
      "Default base price list ID is required"
    ),
    default_factor: Yup.number()
      .required("Discount % is required")
      .max(100, "Discount % cannot exceed 100"),
    margin_factor: Yup.number()
      .required("Margin % is required")
      .max(100, "Margin % cannot exceed 100"),
    rounding_method: Yup.string(),
    rounding_rule: Yup.string(),
  });

  const onSubmit = (values) => {
    const data = {
      default_base_price_list: priceList?.find(
        (item) => item?.value === values?.default_base_price_list_id
      )?.label,
      ...values,
      item_batch_mrp: values.pricing_type === "MRP",
    item_batch_purhcase_rate_before_tax: values.pricing_type === "PR",
    item_batch_ptr: values.pricing_type === "PTR",
    item_batch_pts: values.pricing_type === "PTS",
    };
    const { pricing_type, submittedButton, ...transformData } = data;
    dispatch(priceListEditAction(transformData, onSuccess, onError));
  };
  const handleSelectChange = (event) => {
    setFilterData({ ...filterData, "searchColumn": event?.value });
  };
  const handleChange = (e) => {
    const trimmedValue = e.target.value;
    const cleanedValue = trimmedValue.replace(/[^a-zA-Z0-9 ]/g, "");
    setSearchTerm(cleanedValue);
    setFilterData({ ...filterData, "searchValue": cleanedValue });
  };
  const searchRef = useRef();
  const [searchTerm, setSearchTerm] = useState(filterData?.searchValue || "");
  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.message);
  };
  const onError = (data) => {
    errorToast(data?.data?.message);
  };

  useHotkeys("escape", () => {
    setSelectionCriteria(false);
  });

  function toggleSwitch() {
    const toggleButton = document.getElementById("necessary");
    const isChecked = toggleButton.getAttribute("data-state") === "checked";

    // Toggle the state
    if (isChecked) {
      toggleButton.setAttribute("data-state", "unchecked");
      toggleButton.setAttribute("aria-checked", "false");
    } else {
      toggleButton.setAttribute("data-state", "checked");
      toggleButton.setAttribute("aria-checked", "true");
    }
  }
const handleFileUpload = (event,values) => {
  const is_margin_percentage=values?.is_margin_percentage;
  const price_list_id=values?.price_list_id;
  const file = event.target.files?.[0];
  if (!file) return;

  event.target.value = null;

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: async (results) => {
      const parsedData = results.data;

      if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
        errorToast("Error: The CSV file is empty or contains no valid records.");
        return;
      }
      const headers = (results.meta?.fields || []).map(h => String(h).trim());
      const seen = new Set();
      const duplicates = new Set();

      for (const h of headers) {
        const key = h.toLowerCase();
        if (seen.has(key)) duplicates.add(h);
        else seen.add(key);
      }

      if (duplicates.size > 0) {
        errorToast(`Duplicate header(s) found: ${[...duplicates].join(", ")}`);
        return;
      }
      const requiredBase = ["item_code", "batch_number"];
      const eitherOr = ["percentage", "selling_price"];
      const missingBase = requiredBase.filter((r) => !seen.has(r.toLowerCase()));
      if (missingBase.length > 0) {
        errorToast(`Missing required header(s): ${missingBase.join(", ")}`);
        return;
      }

      const hasEitherOr = eitherOr.some((r) => seen.has(r.toLowerCase()));
      if (!hasEitherOr) {
        errorToast(`Missing required header: either "percentage" or "selling_price" must be present.`);
        return;
      }

      const data={
        "data":parsedData,
        "is_margin":is_margin_percentage,
        "price_list_id":price_list_id,
        item_batch_mrp: values.pricing_type === "MRP",
        item_batch_purhcase_rate_before_tax: values.pricing_type === "PR",
        item_batch_ptr: values.pricing_type === "PTR",
        item_batch_pts: values.pricing_type === "PTS",
      }
      dispatch(priceListEditByCSVAction(data, onSuccess, onError));
    },
    error: (error) => {
      errorToast("Error parsing file:", error);
    },
  });
};

  // Attach the function to the button's click event
  document.getElementById("necessary")?.addEventListener("click", toggleSwitch);
  return (
    <>
      {selectionCriteria === true && (
        <SelectionCriteriaPopover
          setFilterData={setFilterData}
          filterData={filterData}
          setSelectionCriteria={setSelectionCriteria}
          readOnly={type === "view"}
        />
      )}
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, setFieldValue, values }) => {
          return (
            <Form className="h-full pt-5">
              <div className="flex flex-col justify-between h-full ">
                <div className="w-[99%] px-5 border border-[--button-border-color] rounded-md mx-2 py-2">
                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-8 gap-y-6">
                    {/* LEFT COLUMN */}
                    <div className="flex flex-col gap-3 pt-5">
                      <InputField
                        type="text"
                        name="price_list_name"
                        placeholder="Enter name"
                        label="Price Name"
                        isRequired={true}
                      />

                      <SelectField
                        placeholder="Select rounding method"
                        options={roundingMethodoptions}
                        label="Rounding Method"
                        id="rounding_method"
                        name="rounding_method"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                      />

                      <SelectField
                        placeholder="Select rounding rule"
                        options={roundingRuleoptions}
                        label="Rounding Rule"
                        id="rounding_rule"
                        name="rounding_rule"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                      />
                    </div>

                    {/* MIDDLE COLUMN */}
                    <div className="flex flex-col gap-3 border-r border-[--button-border-color] pr-3 pt-5">
                      <SelectField
                        placeholder="Select base price"
                        options={priceList}
                        label="Base Price List"
                        id="default_base_price_list_id"
                        name="default_base_price_list_id"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        isRequired={true}
                      />

                      <InputField
                        isDisabled={values?.is_margin_percentage}
                        max="100"
                        handleChange={(event) => {
                          const value = event?.target?.value;
                          if (parseFloat(value) > 100) {
                            event.preventDefault();
                            errorToast("Discount percentage cannot exceed 100%");
                          }
                        }}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace","Delete","Tab","Escape","Enter",
                            "ArrowLeft","ArrowRight","ArrowUp","ArrowDown",
                            "Home","End","PageUp","PageDown",
                          ];
                          const isNumber = /^[0-9]$/.test(event.key);
                          const isDecimal = event.key === ".";
                          const isAllowedKey = allowedKeys.includes(event.key);

                          if (!isNumber && !isDecimal && !isAllowedKey) {
                            event.preventDefault();
                            errorToast("Only numbers and decimal point are allowed");
                          }
                        }}
                        type="number"
                        name="default_factor"
                        placeholder="Enter discount %"
                        label="Discount Percentage"
                        isRequired={!values?.is_margin_percentage}
                      />

                      <InputField
                        isDisabled={!values?.is_margin_percentage}
                        max="100"
                        handleChange={(event) => {
                          const value = event?.target?.value;
                          if (parseFloat(value) > 100) {
                            event.preventDefault();
                            errorToast("Margin percentage cannot exceed 100%");
                          }
                        }}
                        onKeyDown={(event) => {
                          const allowedKeys = [
                            "Backspace","Delete","Tab","Escape","Enter",
                            "ArrowLeft","ArrowRight","ArrowUp","ArrowDown",
                            "Home","End","PageUp","PageDown",
                          ];
                          const isNumber = /^[0-9]$/.test(event.key);
                          const isDecimal = event.key === ".";
                          const isAllowedKey = allowedKeys.includes(event.key);

                          if (!isNumber && !isDecimal && !isAllowedKey) {
                            event.preventDefault();
                            errorToast("Only numbers and decimal point are allowed");
                          }
                        }}
                        type="number"
                        name="margin_factor"
                        placeholder="Enter margin %"
                        label="Margin Percentage"
                        isRequired={values?.is_margin_percentage}
                      />
                    </div>

                    {/* RIGHT COLUMN */}
                    <div className="flex flex-col gap-6 pt-5">

                      {/* Pricing Type */}
                      <div className="flex flex-col gap-3 text-sm">
                        <label className="fw_600">Pricing Type</label>
                        {priceListConfig.map((cfg) => {
                          if (!cfg?.enabled) return null;
                          const radioValueMap = {
                            item_batch_mrp: "MRP",
                            item_batch_purhcase_rate_before_tax: "PR",
                            item_batch_ptr: "PTR",
                            item_batch_pts: "PTS",
                          };

                          const radioValue = radioValueMap[cfg?.value];
                          if (!radioValue) return null;

                          return (
                            <label key={cfg.value} className="flex items-center gap-2 cursor-pointer">
                              <Field
                                type="radio"
                                name="pricing_type"
                                value={radioValue}
                                className="hidden peer"
                              />
                              <span className="w-3 h-3 rounded-full border border-gray-400 peer-checked:border-primary peer-checked:bg-primary transition-colors" />
                              <span className="text-sm text-gray-800">{cfg.label}</span>
                            </label>
                          );
                        })}
                      </div>

                      {/* Calculation Mode Toggle */}
                      <div className="flex flex-col gap-2 pt-6 border-t border-[var(--button-border-color)]">
                        <label className="fw_600">Calculation Mode</label>

                        <div className="flex gap-4 items-center">
                          <span
                            className={`${values.is_margin_percentage ? "text-disabled-color" : ""}`}
                          >
                            Discount%
                          </span>

                          <button
                            type="button"
                            role="switch"
                            aria-checked={values.is_margin_percentage}
                            onClick={() =>
                              setFieldValue("is_margin_percentage", !values.is_margin_percentage)
                            }
                            data-state={values.is_margin_percentage ? "checked" : "unchecked"}
                            className={`peer inline-flex h-5 w-12 shrink-0 cursor-pointer items-center rounded-full
                              border-2 border-white shadow-sm transition-colors focus-visible:outline-none
                              focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
                              focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50
                              ${values.is_margin_percentage ? "bg-D5E6Ff" : "bg-D5E6Ff"}`}
                            id="toggleSwitch"
                            aria-label="Toggle Switch"
                            title={
                              values.is_margin_percentage
                                ? "Switch to Discount %"
                                : "Switch to Margin %"
                            }
                          >
                            <span
                              data-state={values.is_margin_percentage ? "checked" : "unchecked"}
                              className={`pointer-events-none block h-5 w-5 rounded-full bg-primary shadow-lg ring-0 transition-transform
                                ${values.is_margin_percentage ? "translate-x-7" : "translate-x-0"}`}
                            />
                          </button>

                          <span
                            className={`${values.is_margin_percentage ? "" : "text-disabled-color"}`}
                          >
                            Margin%
                          </span>
                        </div>
                        <div className="flex items-center">
                          <CheckBox
                            conClass="flex flex-wrap justify-between gap-4 fw_600"
                            isDisabled={
                              initialValues?.default_price_list === true
                            }
                            onChange={(fieldName, checked) => {
                              if (checked) {
                                const confirmed = window.confirm(
                                  "Do you want to make this as a default price list?"
                                );
                                if (confirmed) {
                                  setFieldValue(fieldName, true);
                                } else {
                                  // Keep the checkbox unchecked if user cancels
                                  setFieldValue(fieldName, false);
                                }
                              } else {
                                setFieldValue(fieldName, false);
                              }
                            }}
                            items={[
                              {
                                label: "Set as default",
                                name: "default_price_list",
                                isRequired: false,
                              },
                            ]}
                          />
                      </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="py-[14px] ml-2 flex justify-between pb-2">
                  <div
                    style={{ maxWidth: "30rem", height: "34px" }}
                    className={`flex items-center border-radius bg-[var(--head-input-bg-color)]    ${
                      isFocused
                        ? "border border-[var(--head-input-focus-border-color)] "
                        : "border border-[var(--button-border-color)] "
                    }`}
                  >
                    <Select
                      className="border-0 bg-[var(--head-input-bg-color)] text-[var(--head-input-fg-color)] text-[length:--head-input-font-size] font-[var(--head-input-font-weight)] placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:--head-input-font-size] placeholder:font-[var(--head-input-place-font-weight)]"
                      // menuPortalTarget={document.body}
                      styles={customStyles}
                      value={
                        columnOptions.find(
                          (opt) => opt.value === filterData?.searchColumn
                        ) || null
                      }
                      onChange={(e) => {
                        handleSelectChange(e);
                        setIsFocused(true);
                        if (searchRef && searchRef?.current) {
                          searchRef?.current?.focus();
                        }
                      }}
                      options={[
                        {
                          "label":"Item Name",
                          "value":"item_name"
                        },
                        {
                          "label":"Item Code",
                          "value":"item_code"
                        }
                      ]}
                      placeholder="Select Column"
                      isSearchable={false}
                    />
                    <div
                      className={`h-full ${
                        isFocused
                          ? "border-r border-r-[var(--head-input-focus-border-color)] "
                          : "border-r-[var(--button-border-color)] border-r"
                      }`}
                    ></div>{" "}
                    <input
                      maxLength={50}
                      ref={searchRef}
                      autoFocus={true}
                      onBlur={() => setIsFocused(false)}
                      onFocus={() => setIsFocused(true)}
                      placeholder={`Enter keyword`}
                      className="text-[var(--head-input-fg-color)] bg-[var(--head-input-bg-color)] text-[length:--head-input-font-size] font-[var(--head-input-font-weight)] w-full rounded-md  h-full placeholder:text-[var(--head-input-placeholder-color)] placeholder:text-[length:--head-input-font-size] placeholder:font-[var(--head-input-place-font-weight)] px-[8px] focus_outline__none"
                      type="text"
                      // value={filterData?.inputValue}
                      value={searchTerm}
                      onChange={handleChange}
                    />
                    <span className="pr-2">
                      {/* <img
                        style={{
                          height: "16px",
                          width: "16px",
                        }}
                        src={search}
                        alt="search icon"
                      /> */}
                      <SearchIcon size={14} fill="none" stroke="var(--description-color)"/>
                    </span>
                  </div>
                  <div className="flex flex-row">
                    <AddButton
                      onclkFn={() => setSelectionCriteria(!selectionCriteria)}
                      prefixIcon={false}
                      text="Selection Criteria"
                      type="button"
                      className = "bg-[var(--primary-backgorund)] border border-primary mr-2 text-primary px-8 py-2 rounded-md flex justify-center items-center fw_500 text-sm whitespace-nowrap hover:bg-blue hover:text-white transition duration-300 ease-in-out"
                    />
                    {type === "edit" && (
                  <>
                    <input
                      type="file"
                      accept=".csv"
                      className="hidden"
                      id="csv-upload"
                      onChange={(e) => handleFileUpload(e, values)}
                    />

                    <label htmlFor="csv-upload">
                      <div
                        className="flex items-center justify-between px-[12px] h-[44px]
                          whitespace-nowrap rounded-[8px] gap-[10px]
                          bg-[var(--import-button-bg)] cursor-pointer
                          border border-[var(--import-button-border)]
                          hover:bg-[var(--import-button-bg)]
                          text-[var(--import-button-fg)]"
                      >
                        {/* Left side: Excel icon + text */}
                        <div className="flex items-center gap-[8px]">
                          <img width={20} height={20} src={excelImg} alt="excel-icon" />
                          <span>Import CSV</span>
                        </div>

                        <DownloadIcon
                          onClick={(e) => {
                            e.preventDefault();
                            downloadAllTemplates([
                              {
                                "documentType": "Price_List",
                                "expectedHeaders": [
                                  "item_code",
                                  "item_name",
                                  "batch_number",
                                  "percentage",
                                  "selling_price"
                                ]
                              }
                            ]
                            );
                          }}
                          className="w-5 h-5 text-[var(--import-button-fg)]"
                        />
                      </div>
                    </label>
                  </>
                )}

                  </div>
                </div>
                <PriceListItemTable
                  setReload={setReload}
                  reload={reload}
                  paginationProps={paginationProps}
                  priceListData={priceListData}
                  readOnly={!canUpdatePriceList}
                />
                
                {canUpdatePriceList && (
                  <div
                    style={{
                      bottom: "0",
                    }}
                    className="flex justify-end gap-5 px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                  >
                    <AddButton
                      onclkFn={handleSubmit}
                      prefixIcon={false}
                      text="Save"
                      type="submit"
                    />
                  </div>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewPriceList;
export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    // fontSize: "12px",
    fontWeight: "600",
    zIndex: 99,
    backgroundColor: "var(--head-input-bg-color)",
    color: "#344054",
    width: "13rem",
    minHeight: "25px",
    boxShadow: "none", // Remove box shadow
    border: "none",
    borderRadius: "6px",
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "var(--head-input-placeholder-color)",
      // fontFamily: "Inter,sans-serif",
      fontSize: "var(--head-input-font-size)",
      fontWeight: "var(--head-input-place-font-weight)",
      // opacity: "1",
      // position: "absolute",
      // whiteSpace: "nowrap",
    };
  },

  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: "none", // Hide indicator separator
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: "400",
    color: "var(--head-input-fg-color)",
    // fontSize: "12px",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      ...(state.data.color ? { color: state.data.color } : { color: "black" }),
      backgroundColor: state.isSelected ? "#e5ecffb2" : null,
      borderBottom: "1px solid #F5F5F5",
      fontSize: "12px",
      zIndex: 99,
      fontFamily: "Inter,sans-serif",
      "&:hover": {
        backgroundColor: state.isFocused ? "#0000002E" : "#0000002E",
      },
    };
  },

  indicatorContainer: (provided) => ({
    ...provided,
    padding: 0, // Remove padding
  }),
  dropdownIndicator: (provided) => ({
    ...provided,

    fontSize: "14px",
    padding: 0, // Removes padding from the dropdown icon
    fontWeight: "400",
  }),
};
